import { useState } from 'react';
import { Button, HorizontalScroll, useIsMobile } from '@hotelise/ui';
import KPIDashboard from './KPIDashboard';

type KPIMetric = 'income' | 'payouts' | 'expenses' | 'cleaning' | 'adr' | 'revPar' | 'occupancy' | 'alos' | 'ownerBlockedDays';

interface KPITab {
	id: KPIMetric;
	label: string;
}

const KPI_TABS: KPITab[] = [
	{ id: 'income', label: 'Income' },
	{ id: 'payouts', label: 'Net Income' },
	{ id: 'expenses', label: 'Expenses' },
	{ id: 'cleaning', label: 'Cleaning' },
	{ id: 'adr', label: 'ADR' },
	{ id: 'revPar', label: 'RevPAR' },
	{ id: 'occupancy', label: 'Occupancy' },
	{ id: 'alos', label: 'ALOS' },
	{ id: 'ownerBlockedDays', label: 'OOO' },
];

const KPIDashboardTabs = (): JSX.Element => {
	const [activeTab, setActiveTab] = useState<KPIMetric>('income');
	const isMobile = useIsMobile();

	return (
		<div className="w-full">
			{isMobile ? (
				<HorizontalScroll className="mb-4" fadeBg="background">
					{KPI_TABS.map(tab => (
						<Button
							key={tab.id}
							variant={activeTab === tab.id ? 'default' : 'outline'}
							size="sm"
							onClick={() => setActiveTab(tab.id)}
							className="text-xs shrink-0"
						>
							{tab.label}
						</Button>
					))}
				</HorizontalScroll>
			) : (
				<div className="flex flex-wrap gap-2 mb-4">
					{KPI_TABS.map(tab => (
						<Button
							key={tab.id}
							variant={activeTab === tab.id ? 'default' : 'outline'}
							size="sm"
							onClick={() => setActiveTab(tab.id)}
							className="text-xs"
						>
							{tab.label}
						</Button>
					))}
				</div>
			)}
			<KPIDashboard kpiMetric={activeTab} />
		</div>
	);
};

export default KPIDashboardTabs;
